import { CONTENT_REVIEWED, PUBLISHER, WEBSITE_ID } from './organization';
import { ogImageFor } from './ogImage';

export type Faq = { question: string; answer: string };

export function faqSchema(items: readonly Faq[]) {
  return { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items.map(item => ({ '@type': 'Question', name: item.question, acceptedAnswer: { '@type': 'Answer', text: item.answer } })) };
}

/** Article JSON-LD. Dates default to the site-wide review date; pass a page's own publish and update dates when it has them. */
export function articleSchema({ headline, description, url, about, datePublished = CONTENT_REVIEWED, dateModified = datePublished, image = ogImageFor(url) }: { headline: string; description: string; url: string; about?: object; datePublished?: string; dateModified?: string; image?: string }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    url,
    mainEntityOfPage: url,
    inLanguage: 'en',
    isPartOf: { '@id': WEBSITE_ID },
    datePublished,
    dateModified,
    ...(image ? { image } : {}),
    author: PUBLISHER,
    publisher: PUBLISHER,
    ...(about ? { about } : {}),
  };
}
